import template from './delivery_region_routing.html';
import controller from './delivery_region_routing.controller';
import './delivery_region_routing.scss';

let deliveryRegionRoutingComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL:'='
    },
    template,
    controller
}

export default deliveryRegionRoutingComponent;


// WEBPACK FOOTER //
// ./client/app/components/delivery_region_routing/delivery_region_routing.component.js